export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const CHANGE_PIC = "CHANGE_PIC"
export const CHANGE_NAME = "CHANGE_NAME"